const convertToSlug = (title = '') => title.toLowerCase().replaceAll(' ', '-');

const getHelpCategory = (slug, subCategory) => {
  const base = '/help/category';

  if (slug) {
    if (subCategory) {
      return `${base}/${slug}/#${subCategory}`;
    }
    return `${base}/${slug}/`;
  }

  return base;
};

const getHelpArticle = (slug) => {
  const base = '/help/article';

  if (slug) {
    return `${base}/${slug}/`;
  }

  return base;
};

const getHelpSearch = (query) => {
  const base = '/help/search/';

  if (query) {
    return `${base}?term=${query}`;
  }

  return base;
};

const getSolutionArticle = (slug) => {
  const base = '/solutions';

  if (slug) {
    return `${base}/${slug}/`;
  }

  return base;
};

const getComparisonArticle = (slug) => {
  const base = '/compare';

  if (slug) {
    return `${base}/${slug}/`;
  }

  return base;
};

const getTemplateLibrary = (base, id) => `${base}/template/${id}/`;

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default {
  convertToSlug,
  getHelpCategory,
  getHelpArticle,
  getHelpSearch,
  getSolutionArticle,
  getComparisonArticle,
  getTemplateLibrary,
};
